import React from "react";
import Header from "../component/Header";
import Footer from "../component/Footer";
import ExploreResultLocations from "../component/ExploreResultLocations";
import Testimonials from "../component/Testimonials";
import AboutBanner from "../component/AboutBanner";
import AboutBox from "../component/AboutBox";
import AboutMakingHome from "../component/AboutMakingHome";
function AboutUs() {
  return (
    <>
      <div className="main about-us-page">
        <Header />
        <AboutBanner />
        <AboutMakingHome />
        <AboutBox />  
        <Testimonials />
        <ExploreResultLocations />
        <Footer />
      </div>
    </>
  );
}
export default AboutUs;
